import Colors from "./Colours";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.buttonBGColor,
    },
    secondary: {
      main: "#DC004E",
    },
    background: {
      //default: "#fff",
    },
    text: {
      primary: "#000",
      secondary: "#000",
      disabled: "#84818A",
    },
  },

  typography: {
    fontFamily: ["Poppins", "Arial", "Helvetica", "sans-serif", "Inter"].join(
      ","
    ),
    h1: {
      fontSize: "2.5rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 500,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
      secondaryText: {
        color: "rgba(89, 89, 89, 1)",
      },
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    button: {
      fontSize: "1rem",
      fontWeight: 500,
      textTransform: "none",
    },
  },
  components: {
    MuiPopover: {
      styleOverrides: {
        root: {
          "&.MuiPopover-root": {
            position: "absolute",
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          "@media (min-width: 600px)": {
            paddingLeft: "48.8px",
            paddingRight: "48.8px",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          padding: "10px",
          width: "100%",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          ".MuiPagination-ul": {
            gap: "12px",

            "& .MuiPaginationItem-root": {
              fontFamily: "Poppins, sans-serif",
              borderRadius: "4px",
              border: "1px solid #EEEEEE",
              background: "#F5F5F5",
              color: "#2D2D43",
              minWidth: "25px",
              height: "24px",
              paddingY: "6px",
              margin: "0px",

              "&.Mui-selected": {
                color: "white",
                background: "#2F4DDB",
                border: "1px solid #5932EA",
              },
              "&:hover": {
                background: "#E0E0E0",
              },
              "&:focus, &:active": {
                background: "#2F4DDB",
                border: "1px solid #5932EA",
                color: "white",
              },
            },
          },
        },
      },
    },
    MuiStep: {
      styleOverrides: {
        alternativeLabel: {
          "&.MuiStep-alternativeLabel ": {
            " .MuiStepLabel-label": {
              "&.Mui-active": {
                color: Colors.progressColor,
              },
              "&.Mui-completed": {
                color: Colors.progressColor,
              },
              "&.Mui-disabled": {
                color: Colors.textColor2,
              },
            },
          },
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          top: "16px",
          ".MuiStepConnector-line": {
            borderWidth: "8px",
          },
          "&.Mui-active .MuiStepConnector-line": {
            borderColor: Colors.progressColor,
          },
          "&.Mui-completed .MuiStepConnector-line": {
            borderColor: Colors.progressColor,
          },
          "& .MuiStepConnector-line": {
            borderColor: Colors.progressColorInactive,
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          "&.MuiTableContainer-root": {
            borderRadius: "6px",
            overflowX: "none",

            boxShadow: "none",
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "",
          color: "",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          "&.MuiTableCell-root": {
            padding: "11px",
            fontFamily: "Poppins, sans-serif",
          },
        },
      },
    },
  },
});
export default theme;
